import { render } from "./VendorsWithdrawalsCreate.vue?vue&type=template&id=53a2e846"
import script from "./VendorsWithdrawalsCreate.vue?vue&type=script&lang=js"
export * from "./VendorsWithdrawalsCreate.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__